import React from 'react';
import { Outlet } from 'react-router-dom';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {
  Box,
  Paper,
  Tab,
  Tabs,
} from '@mui/material';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';

const ScheduleMngPage = () => {
  const location = useLocation();
  const currentTab = location.pathname.includes('/schedulemng/manufacturing')
    ? '/schedulemng/manufacturing'
    : '/schedulemng/sales';

  return (
    <>
      <BreadcrumbsContainer title="공통관리/스케줄 관리" icon="schedule" />

      <Box sx={{ px: 2, pb: 3 }}>
        <Paper
          sx={{
            mb: 2,
            borderRadius: 3,
            boxShadow: 'none',
            border: '1px solid',
            borderColor: 'divider',
            overflow: 'hidden',
          }}
        >
          <Tabs
            value={currentTab}
            variant="fullWidth"
            sx={{
              '& .MuiTab-root': {
                minHeight: 56,
                fontWeight: 700,
              },
            }}
          >
            <Tab
              label="영업 캘린더"
              value="/schedulemng/sales"
              component={RouterLink}
              to="/schedulemng/sales"
            />
            <Tab
              label="제조 스케줄러"
              value="/schedulemng/manufacturing"
              component={RouterLink}
              to="/schedulemng/manufacturing"
            />
          </Tabs>
        </Paper>

        <Outlet />
      </Box>
    </>
  );
};

export default ScheduleMngPage;
